import { useEffect, useMemo } from 'react';
import { useFieldRegistry } from '../Form/FieldRegistry';
export default function useRegisterField(label, name) {
    const { isFormDisabled, showAllErrors, registerField, deregisterField } = useFieldRegistry();
    const fieldContextData = useMemo(() => ({ label, name }), [label, name]);
    useEffect(() => {
        registerField(fieldContextData);
        return () => deregisterField(fieldContextData.name);
    }, [fieldContextData, registerField, deregisterField]);
    return { isFormDisabled, showAllErrors };
}
//# sourceMappingURL=useRegisterField.js.map